/**
 * TNK-132 — Listing Templates moved to /settings/listing-templates
 * because the operator edits them like a setting (set-once, reuse
 * many times) rather than reaching for them as a daily utility.
 * Thin redirect kept here for bookmarks / muscle memory.
 */
import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/tools/templates")({
  component: TemplatesMovedRedirect,
});

function TemplatesMovedRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: "/settings/listing-templates", replace: true });
  }, [navigate]);
  return (
    <div className="mx-auto max-w-md py-12 text-center text-muted-foreground">
      <Loader2 size={20} className="mx-auto animate-spin" />
      <p className="mt-3 text-sm">Moved to Settings → Listing Templates…</p>
    </div>
  );
}
